<script>
  import CookieConsent from 'cookieconsent'

  export default {
    props: ['message', 'button'],

    mounted () {
      cookieconsent.initialise({
        container: this.$el,
        position: 'top',
        static: true,
        showLink: false,
        content: {
          message: this.message,
          dismiss: this.button
        }
      })
    }
  }
</script>

<template>
  <div></div>
</template>

<style lang="scss">
  @import "../sass/variables";
  @import '~cookieconsent/build/cookieconsent.min.css';

  .cc-window {
    justify-content: space-between;
  }

  .cc-message {
    max-width: 792px;
    font-size: 1.125rem;
  }

  .cc-btn {
    background: $blue;
    color: $pippin;
    border: 0;
    font-family: 'Separat';
    text-transform: uppercase;
    font-size: 1.25rem;
  }
</style>



// WEBPACK FOOTER //
// partials/Cookie.vue